module.exports = __webpack_public_path__ + "img/irq.be991997.svg";